module.exports = __webpack_public_path__ + "static/img/home_xuanfu_img_banner5@2x.552febd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeImg/home_xuanfu_img_banner5@2x.png
// module id = vDpx
// module chunks = 0